import { get as objectGet } from '../../helpers/object-get';

const get = (option: any, bind: string) => {
  if (typeof option === 'object') {
    return objectGet(option, bind || '');
  }

  return option;
};

export const SelectHelper = {
  get,
};
